import React from 'react';
import { NavDropdown } from 'react-bootstrap';
import setQuery from '../../lib/setQuery.js';
import { Link } from 'react-router-dom';
import { logoutAndRedirect } from '../../redux/actions/userActions.js';
import { action } from '../../lib/actionHelpers.js';
import { useSelector } from 'react-redux';
import selectors from '../../selectors/selectors.js';
import { useHistory } from 'react-router';
import SVG from '../../images/svg/SVG.js';
import { postRedisDbCacheFlush } from '../../redux/actions/appActions.js';
import {SETTINGS_ACCESS} from "../../lib/constants/permissions";

const AppHeaderUserDropdown = () => {
  const { replace } = useHistory();

  const user = useSelector((state) => state.user) || {};
  const serviceProviderId = useSelector(selectors.serviceProviderId);
  const tresioUser = useSelector((state) => state.user.tresioUser);
  const canAccessSettings = useSelector(selectors.hasPermission(SETTINGS_ACCESS));

  let logOut = (e) => {
    e.preventDefault();
    logoutAndRedirect({ saveRedirectPath: false });
    action('CLEAR_PROVIDER_STATE');
  };

  const handleFlushClick = () => {
    postRedisDbCacheFlush();
  };

  if (!user.id) {
    return null;
  }

  return (
    <NavDropdown className={'header-user-dropdown'} title={`${user.profile.first_name[0]}${user.profile.last_name[0]}`} id={'header-user-dropdown'}>
      {!!serviceProviderId && (
        <>
          <NavDropdown.Item as={'li'} onClick={() => setQuery({ profile_view: true })}>
            <SVG icon={'User'} basic={true} />
            <span>Profile</span>
          </NavDropdown.Item>
          {canAccessSettings && (
            <NavDropdown.Item as={'li'} onClick={() => replace({ pathname: `/${serviceProviderId}/settings/general` })}>
              <SVG icon={'Settings'} basic={true} />
              <span>Settings</span>
            </NavDropdown.Item>
          )}
          {tresioUser && (
            <NavDropdown.Item as={'li'} onClick={handleFlushClick}>
              <SVG icon={'TodoAlert'} basic={true} />
              <span>Flush Redis Cache</span>
            </NavDropdown.Item>
          )}
          <NavDropdown.Divider />
        </>
      )}
      <NavDropdown.Item as={'li'} onClick={() => window.open('/help', '_blank')}>
        <SVG icon={'Help'} basic={true} />
        <span>Help</span>
      </NavDropdown.Item>
      <NavDropdown.Item as={'li'} onClick={(e) => logOut(e)}>
        <SVG icon={'Logout'} basic={true} />
        <Link to={`/login`}>Logout</Link>
      </NavDropdown.Item>
    </NavDropdown>
  );
};

export default AppHeaderUserDropdown;
